import { useMemo } from 'react';

import { useIsVivaInsightsNetworkEnabled } from '../../featureChecks';
import type { UseMainUIFeatureSettings } from '../../types';
import { uiFeatureAccessSymbol } from '../../types';

export const useInsightsNetworkPageSettings: UseMainUIFeatureSettings<'insightsNetworkPage'> = (options) => {
  const insightsNetworkPageOverrides = options?.overrides?.insightsNetworkPage;

  const isInsightsNetworkEnabled = useIsVivaInsightsNetworkEnabled();

  return useMemo(
    () => ({
      [uiFeatureAccessSymbol]: isInsightsNetworkEnabled,
      ...insightsNetworkPageOverrides,
    }),
    [isInsightsNetworkEnabled, insightsNetworkPageOverrides]
  );
};
